import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "method", "endpoint", "group", "empty", "clear"]

  connect() {
    this.filter()
  }

  filter() {
    const query = this.queryTarget.value.trim().toLowerCase()
    const method = this.methodTarget.value
    const filtering = query.length > 0 || method.length > 0

    this.endpointTargets.forEach((endpoint) => {
      const matchesQuery = query.length === 0 || endpoint.dataset.search.includes(query)
      const matchesMethod = method.length === 0 || endpoint.dataset.method === method

      endpoint.hidden = !(matchesQuery && matchesMethod)
    })

    let visibleCount = 0

    this.groupTargets.forEach((group) => {
      const endpoints = Array.from(group.querySelectorAll("[data-api-documentation-filter-target~='endpoint']"))
      const visibleEndpoints = endpoints.filter((endpoint) => !endpoint.hidden)
      const visible = visibleEndpoints.length > 0

      group.hidden = !visible
      visibleCount += visibleEndpoints.length

      if (visible) {
        this.setGroupExpanded(group, filtering || group.dataset.defaultOpen === "true")
      }
    })

    this.emptyTarget.hidden = visibleCount > 0
    this.clearTarget.hidden = !filtering
  }

  clear() {
    this.queryTarget.value = ""
    this.methodTarget.value = ""
    this.filter()
    this.queryTarget.focus()
  }

  setGroupExpanded(group, expanded) {
    const button = group.querySelector(".accordion-button")
    const collapse = group.querySelector(".accordion-collapse")

    if (!button || !collapse) return

    button.classList.toggle("collapsed", !expanded)
    button.setAttribute("aria-expanded", expanded.toString())
    group.open = expanded
  }
}
